import { Injectable } from "@angular/core";
import * as CryptoJS from "node_modules/crypto-js";
import { environment } from '../../../environments/environment';

@Injectable()
export class UtilService {
    public static encrypt(msg: string) {
        var pass = environment.encryptionKey;
        var keySize = 256;
        var salt = CryptoJS.lib.WordArray.random(16);
        var key = CryptoJS.PBKDF2(pass, salt, {
          keySize: keySize / 32,
          iterations: 1000,
        });
        var iv = CryptoJS.lib.WordArray.random(128 / 8);
        var encrypted = CryptoJS.AES.encrypt(msg, key, {
          iv: iv,
          padding: CryptoJS.pad.Pkcs7,
          mode: CryptoJS.mode.CBC,
        });
        var saltwords = this.wordArrayToByteArray(salt);
        var ivwords = this.wordArrayToByteArray(iv);
        var cryptedText = this.wordArrayToByteArray(encrypted.ciphertext);
        var header = saltwords.concat(ivwords).concat(cryptedText);
        var headerWords = this.byteArrayToWordArray(header);
        var encodedString = CryptoJS.enc.Base64.stringify(headerWords);
        return encodedString;  
        }
    static wordArrayToByteArray(wordArray) {
        if (wordArray.hasOwnProperty("sigBytes") && wordArray.hasOwnProperty("words")) {
          length = wordArray.sigBytes;
          wordArray = wordArray.words;
        }
        var result = [],bytes,i = 0;
        while (length > 0) {
          bytes = this.wordToByteArray(wordArray[i], Math.min(4, length));
          length -= bytes.length;
          result.push(bytes);
          i++;
         }
         return [].concat.apply([], result);
    }
    
    static byteArrayToWordArray(ba) {
        var wa = [],i;
        for (i = 0; i < ba.length; i++) {
          wa[(i / 4) | 0] |= ba[i] << (24 - 8 * i);
        }
        return CryptoJS.lib.WordArray.create(wa);
    }
    static wordToByteArray(word, length) {
        var ba = [],
        xFF = 0xff;
        if (length > 0) ba.push(word >>> 24);
        if (length > 1) ba.push((word >>> 16) & xFF);
        if (length > 2) ba.push((word >>> 8) & xFF);
        if (length > 3) ba.push(word & xFF);
        
        return ba;
    }
}